import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    type: 2,
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/newton_profile.png",
      alt: "Newton Linchen",
    },
    logo: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/logos_newton-01.svg",
    title: "Resultados superiores com algoritmos",

    // String ou array de strings
    text: "Nossa estratégia utiliza algoritmos de machine learning para interpretar o mercado e decidir o ponto exato para negociar. Ela opera o mini-índice futuro e é ajustada para volatilidade dos mercados de alta, lateral e de baixa.",
    testimonial: {
      text: "Experiência de 17 anos no mercado, alinhada com o estado-da-arte em machine learning. O resultado só poderia ser positivo.",
      author: {
        name: "Newton Linchen, Analista CNPI-T (Mestrado - UFRGS - Ciência da Computação)",
        picture: "",
      },
    },
  },

  strategies: {
    title: "Algoritmo de mini-índice",
    heading: "Desenvolvido para Resultados Superiores",
    subtitle:
      "Coloque os algoritmos mais modernos de day trading para rodar na sua conta, com apenas alguns cliques.",
  },

  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Ative agora mesmo o Algoritmo de mini-índice de Newton Linchen.",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "Newton Linchen",
    col1: [
      "Sou Newton Linchen, desenvolvedor de algoritmos e Analista CNPI-T com 17 anos de experiência no mercado. Você deve me conhecer como autor do livro 'Lucrando Com Os Tubarões' (Novatec, 2011). Iniciei a operar em 2006 e comecei minhas operações no mini-índice desde o seu lançamento, em 2007. Em 2008 a crise mundial me ensinou a importância de ter uma abordagem quantitativa, e isso mudou completamente minha forma de ver o mercado.",
    ],
    col2: [
      "De 2009 a 2014 desenvolvi um método de análise quantitativo, utilizando Estatística e Probabilidade. De 2015 a 2019, desenvolvi robôs na plataforma Metatrader. Em 2020, porém, minha visão do mercado mudaria de novo (para melhor), com a minha entrada no Mestrado em Ciência da Computação na Universidade Federal do Rio Grande do Sul (UFRGS). Lá aprendi a utilizar os algoritmos que hoje fazem parte deste produto: algoritmos de machine learning, uma área da inteligência artificial desenvolvida para resolver problemas de previsão.",
    ],
  },

  stats: {
    title: "Alguns números do Newton Linchen",
    subtitle: "Números que realmente importam.",
    data: [
      {
        value: "278%",
        description: "de retorno global.",
      },
      {
        value: "15%",
        description: "de retorno médio mensal.",
      },
      {
        value: "275%",
        description: "acima do Ibovespa no período!",
      },
    ],
  },

  picture: {
    url: "https://ontick-img.s3.sa-east-1.amazonaws.com/nl_resultado.jpeg",
    description:
      "Algoritmo de Mini-índice x Ibovespa. Atualizado em 12 de setembro de 2022.",
  },

  features: {
    title: "Por que utilizar o algoritmo de Newton Linchen?",
    subtitle: "Entenda as principais vantagens de usar nosso algoritmo:",
    data: [
      {
        icon: iconsSet.growth,
        title: "Resultados superiores",
        description:
          "Nossa estratégia ultrapassou consistentemente a performance do Ibovespa no período, trazendo resultados acima do benchmark. Esse é o reflexo da qualidade da pesquisa envolvida no algoritmo.",
      },
      {
        icon: iconsSet.code,
        title: "Adaptação ao mercado",
        description:
          "A característica mais marcante dos algoritmos de machine learning é a sua capacidade de aprender com novas informações do mercado. Desse modo, a estratégia se mantém adaptada e relevante para gerar resultados em qualquer cenário.",
      },
      {
        icon: iconsSet.tune,
        title: "Controle de risco",
        description:
          "A estratégia utiliza alvos de lucro e stop-loss adequados à volatilidade, com stop móvel para proteção de lucros e controle efetivo de risco.",
      },
      {
        icon: iconsSet.graduation_cap,
        title: "Equipe altamente qualificada",
        description:
          "Nossa equipe conta com Mestres em Ciência da Computação, Ph.D em Matemática, Cientistas de Dados e Programadores de alto nível para manter o algoritmo sempre atualizado com o que há de mais moderno em tecnologia para resultados.",
      },
      {
        icon: iconsSet.chat_round,
        title: "Suporte personalizado",
        description:
          "Atendemos os clientes em um grupo no Telegram e estamos sempre acessíveis para tirar dúvidas e responder questionamentos sobre o andamento da estratégia.",
      },
      {
        icon: iconsSet.money,
        title: "Liberdade financeira",
        description:
          "Você pode adicionar nossa estratégia em seu plano de liberdade financeira, aumentando o capital destinado a ela à medida que os resultados aparecem. Quanto maior seu comprometimento, maior o potencial retorno.",
      },
      // ...defaultContent.features.data,
    ],
  },

  plans: {
    title: "Planos",
    subtitle: "Escolha o plano mais adequado para você:",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
